__turbopack_context__.v({
  "blocksBackgroundColor": "NotificationsIcon-module-scss-module__TtQ2BW__blocksBackgroundColor",
  "blocksFontColor": "NotificationsIcon-module-scss-module__TtQ2BW__blocksFontColor",
  "notificationIcon": "NotificationsIcon-module-scss-module__TtQ2BW__notificationIcon",
  "secondaryNavBackgroundColor": "NotificationsIcon-module-scss-module__TtQ2BW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "NotificationsIcon-module-scss-module__TtQ2BW__themeBackgroundColor",
  "themeFontColor": "NotificationsIcon-module-scss-module__TtQ2BW__themeFontColor",
});
